import PropTypes from "prop-types";

import Presenter from "utils/PropTypesPresenter";

export default new Presenter(
  {
    id: PropTypes.string,
    type: PropTypes.string,
    animatedThumb: PropTypes.string,
    thumbnail: PropTypes.string,
  },
  {
    thumb(tg) {
      return this.thumbnail(tg);
    },

    castsCount(tg) {
      const { castNumOptions } = tg;
      return castNumOptions[0];
    },
  },
);
